/** Comfortable overlay primitives — same scale as the main site. */

export const overlayBackdrop =
  "bg-black/20 duration-200 supports-backdrop-filter:backdrop-blur-sm data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0";

export const overlayMotion =
  "duration-200 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95";

export const overlaySlideMotion =
  "data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-start-2 data-[side=inline-start]:slide-in-from-end-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2";

export const overlayMenuShell =
  "rounded-xl bg-popover p-1.5 text-[15px] text-popover-foreground shadow-lg ring-1 ring-foreground/10";

export const overlayMenuItem =
  "min-h-10 gap-2 rounded-lg px-3 py-2 text-[15px]";

export const overlayMenuLabel =
  "px-3 py-2 text-xs font-medium text-muted-foreground";
